"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSfraApiGiftCertCheckBalance = useSfraApiGiftCertCheckBalance;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _useQuery = require("../../useQuery");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useSfraApiGiftCertCheckBalance(args, options) {
  if (!args.query.giftCertID) {
    throw new Error('giftCertID is required for useSfraApiGiftCertCheckBalance.');
  }
  return (0, _useQuery.useQuery)(['sfraApiGiftCertCheckBalance', args], (_, {
    giftCertificates: service
  }) => service.checkBalance(args).catch(() => {
    return {
      error: true,
      ErrorMsg: 'An technical error occured on useSfraApiGiftCertCheckBalance.'
    };
  }), _objectSpread(_objectSpread({}, options), {}, {
    cacheTime: 0
  }));
}